import { Phone, CalendarCheck, MessageCircle } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { useModal } from "../context/ModalContext";

export function FloatingButtons() {
  const { settings } = useSettings();
  const { open } = useModal();
  const wa = settings.whatsapp || "https://wa.me/447956120510";

  return (
    <>
      {/* Desktop floating WhatsApp + Call */}
      <div className="fixed right-4 bottom-6 z-[115] flex-col gap-3 hidden md:flex">
        <a
          href={wa} target="_blank" rel="noopener noreferrer"
          className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-glow hover:scale-110 transition-transform"
          style={{ boxShadow: "0 10px 30px rgba(37,211,102,0.45)" }}
          aria-label="Chat on WhatsApp" data-testid="whatsapp-float"
        >
          <MessageCircle size={26} />
        </a>
        <a
          href={`tel:${settings.phone_link || ""}`}
          className="w-14 h-14 rounded-full brand-gradient text-white flex items-center justify-center shadow-glow hover:scale-110 transition-transform"
          aria-label="Call now" data-testid="call-float"
        >
          <Phone size={24} />
        </a>
      </div>

      {/* Mobile sticky CTA bar */}
      <div className="mobile-sticky-cta fixed bottom-0 left-0 right-0 z-[115] md:hidden glass border-t border-black/10 px-3 pt-2.5 flex gap-2" data-testid="mobile-sticky-cta">
        <a href={`tel:${settings.phone_link || ""}`} className="btn-outline min-w-0 flex-1 !px-2 !py-2.5 !gap-1.5 text-sm" data-testid="mobile-call">
          <Phone size={16} /> Call
        </a>
        <a href={wa} target="_blank" rel="noopener noreferrer" className="min-w-0 flex-1 flex items-center justify-center gap-1.5 rounded-full bg-[#25D366] text-white font-semibold text-sm px-2 py-2.5" data-testid="mobile-whatsapp">
          <MessageCircle size={16} /> <span className="mobile-cta-label--wide">WhatsApp</span><span className="mobile-cta-label--compact hidden">Chat</span>
        </a>
        <button onClick={() => open("booking")} className="btn-primary min-w-0 flex-1 !px-2 !py-2.5 !gap-1.5 text-sm" data-testid="mobile-book">
          <CalendarCheck size={16} /> Book
        </button>
      </div>
    </>
  );
}
